import { ProductOption } from "./product_option";
import { AttributeGroup } from "./attribute_group";
import { Discount } from "./discount";
import { Option } from "./option";

export class Product {
    public id: number;
    public uid: string;
    public old_uid: string;
    public name: string;
    public product_image: string;
    public short_des: string;
    public full_des: string;
    public manufacturer: string;
    public product_sku: string;
    public price: number;
    public quantity = 1;
    public attributes: AttributeGroup[];
    public options: ProductOption[];
    public supplier: string;
    public selected_attr: string;
    public sale_price: number = 0; // Sale price
    public ori_price: number = 0; // Product price
    public discount: Discount = null;
    public is_error: boolean = false;
    public action: string = 'add';
    public message: string = '';
    public in_stock: number = 0;
    public weight_name: string = '';
    public unit: string = '';
    public pro_info: string = '';
    public summary: string = '';
    public weight = 0;
    public limit_message: string;
    public ship_limit: false;
    public ship_area: Array<number>;
    public check_quantity = true;
    public check_weight = false;
    public total_weigth = 0;
    public wishlished = 0;
    public product_offline = '0';
    public selected_weight: number = 0;
    public selected_op: Array<string> = [];
    public used_date: Date = null;
    public minDate: Date;
    public maxDate: Date;
    public disabledDates: Date[] = [];

    constructor(item: Object) {
        Object.keys(item).forEach((prop) => {
            this[prop] = item[prop]
        });
        this.price = +this.price;
        this.ori_price = +this.ori_price;
        this.weight = +this.weight;
        this.total_weigth = +this.total_weigth;
        this.in_stock = +this.in_stock;

        this.sale_price = +this.sale_price;
        if (this.sale_price == 0) {
            this.sale_price = this.price;
        }
        if (this.total_weigth > 0) {
            this.check_weight = true;
            this.check_quantity = false;
        }
        this.wishlished = +this.wishlished;

    }

    validateStock(quantity: number) {
        let result = false;
        if (this.used_date == null) {
            return false;
        }
        if (this.check_quantity) {
            if (quantity <= this.in_stock) {
                result = true;
            }
        }

        if (this.check_weight) {
            if (this.total_weigth >= this.getProductWeight() * quantity) {
                result = true;
            }
            console.log('total weight', this.total_weigth);
            console.log('request weight', this.getProductWeight() * quantity);
        }
        return result;
    }

    /**
     * Increase quantity
     */
    increase() {
        const result = this.validateStock(this.quantity + 1);
        if (result) {
            this.quantity += 1;
        }

        return result;
    }

    /**
     * Descrease quantity
     */
    descrease() {
        if (this.quantity > 1) {
            this.quantity -= 1;
        }
        return true;
    }

    setUsedDate(useDate: Date) {
        this.used_date = useDate;
    }

    clearUseDate() {
        this.used_date = null;
    }

    checkQty(qty: number) {
        const result = this.validateStock(qty);
        if (result) {
            this.quantity = qty;
        }

        return result;
    }

    makeUniqueKey() {
        let attr = [];
        let attr_name = [];
        if (this.options && this.options.length) {
            attr = this.options.map((item) => {
                return item.selected.join(':');
            });
            attr = attr.sort(this.sort);
            attr_name = this.options.map((item) => {
                let opName = [];
                for (let attribute_item of item['options']) {
                    if (item.selected.indexOf(attribute_item['id']) !== -1) {
                        opName.push(attribute_item['text']);
                    }
                }
                if (opName.length) {
                    return item['option_name'] + ': ' + opName.join(',');
                }
            });
            attr_name = attr_name.filter(function (el) {
                return el != null;
            });
            this.selected_attr = attr_name ? attr_name.join('/') : '';
        }
        if (this.used_date != null) {
            attr.push(this.used_date.toLocaleDateString('en-US'));
        }
        return attr.join('_');
    }

    setUid() {
        this.uid = this.makeUniqueKey();
    }

    sort(n1: number, n2: number) {
        return n1 - n2;
    }

    /**
     * Get sale price
     */
    getSalePrice(): void {
        let addtionalPrice = 0;
        if (this.options && this.options.length) {
            this.options.map((item) => {
                item.options.map(op => {
                    if (!(op instanceof Option)) {
                        op = new Option(op);
                    }
                    if (op.selected) {
                        addtionalPrice += op.getAdditionalPrice(this.ori_price);
                    }
                });
            });
        }
        if (this.discount && this.discount.id) {
            console.log(this.discount);
            addtionalPrice = this.discount.getAdditionalPrice(addtionalPrice);
        }
        console.log(addtionalPrice);
        this.sale_price = this.ori_price + addtionalPrice;
    }

    /**
     * Get sale price
     */
    getProductWeight(): number {
        let weight = this.weight;
        if (!this.options) {
            return weight;
        }
        this.options.map((item) => {
            item.options.map(op => {
                // @ts-ignore
                if (op.selected) {
                    const selectOption = new Option(op);
                    weight += selectOption.getAdditionalWeight();
                }
            });
        });

        return weight;
    }

    /**
     * Make cart item
     */
    getCartItem() {
        const uid = this.id + '_' + this.makeUniqueKey();
        return {
            id: this.id,
            uid: this.id + '_' + this.makeUniqueKey(),
            name: this.name,
            product_image: this.product_image,
            price: this.price,
            ori_price: this.ori_price,
            sale_price: this.sale_price,
            quantity: this.quantity,
            unit: this.unit,
            attributes: this.attributes,
            options: this.options,
            selected_attr: this.selected_attr,
            selected_op: this.options ? this.options.map((item) => {
                return item.selected.join(':');
            }) : '',
            action: this.action,
            old_uid: this.uid ? this.uid : uid,
            weight: this.weight,
            ship_area: this.ship_area,
            limit_message: this.limit_message,
            in_stock: this.in_stock,
            total_weigth: this.total_weigth,
            selected_weight: this.getProductWeight(),
            used_date: this.used_date,
            minDate: this.minDate,
            maxDate: this.maxDate,
            disabledDates: this.disabledDates,
        };
    }

}



// WEBPACK FOOTER //
// ./src/bean/shop/product.ts